import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Icons } from "@texada/ui";
import { getIcon, MenuItem, getMenuItemUrl, BaseMenuItem } from "./menuItems";
import { MainSideMenuContext } from "./MainSideMenu";
import { collapseSidebar } from "actions";

export interface SidebarSectionProps {
  hasSubMenu: boolean;
  item: MenuItem | BaseMenuItem;
}

function useCloseSidebar() {
  const dispatch = useDispatch();
  return () => dispatch(collapseSidebar());
}

const SidebarSection = React.memo<SidebarSectionProps>(function SidebarSection({
  hasSubMenu,
  item
}) {
  const closeSidebar = useCloseSidebar();
  const { isNavOpen, isMobile, isActive, setSelectedItem } =
    useContext(MainSideMenuContext);
  const active = isActive(item);

  if (!hasSubMenu) {
    return (
      <NavLink
        role="menuitem"
        to={getMenuItemUrl(item)}
        exact={false}
        isActive={() => active}
        activeClassName="side_nav_selected"
        onClick={closeSidebar}
      >
        <span className="side_nav_icon-text">
          {!isNavOpen && (
            <span className="side_nav_icon-dot">
              &nbsp;
              <Icons.Ellipse />
              &nbsp;
            </span>
          )}
          {isNavOpen && (
            <span className="side_nav_menu-text">{item.label}</span>
          )}
        </span>
      </NavLink>
    );
  }

  return (
    <NavLink
      role="menuitem"
      to={getMenuItemUrl(item)}
      exact={false}
      isActive={() => active}
      activeClassName="side_nav_selected"
      onClick={e => {
        if (!e.defaultPrevented) closeSidebar();

        const sideNavChildUl: HTMLUListElement = e.currentTarget
          .nextElementSibling as any;
        const navArrrow: HTMLSpanElement = e.currentTarget.firstChild
          .lastChild as any;

        if (active) {
          if (!sideNavChildUl.classList.contains("side_nav_display")) {
            navArrrow.classList.remove("side_nav_display");
          }

          sideNavChildUl.classList.toggle("side_nav_display");
          navArrrow.classList.toggle("side_nav_display");
        } else if (
          e.currentTarget.classList.contains("side_nav_display") === false
        ) {
          navArrrow.classList.remove("side_nav_display");
          if (sideNavChildUl)
            sideNavChildUl.classList.remove("side_nav_display");
        }
      }}
    >
      <span className="side_nav_icon-text">
        {getIcon(item.label)}
        {isNavOpen && <span className="side_nav_menu-text">{item.label}</span>}
        {"children" in item && isMobile && (
          <span
            role="button"
            tabIndex={0}
            className="side_nav_menuArrow"
            onClick={e => {
              e.preventDefault();
              setSelectedItem(item);
            }}
          >
            <Icons.KeyboardArrowLeft className="arrow" />
          </span>
        )}
      </span>
    </NavLink>
  );
});

export default SidebarSection;
